/** Shared customer-facing brand tagline for web, native and document headers. */
export const BRAND_TAGLINE = 'Crafted for the Uncommon';
